import { render, staticRenderFns } from "./BellList.vue?vue&type=template&id=26627674&scoped=true&"
import script from "./BellList.vue?vue&type=script&lang=js&"
export * from "./BellList.vue?vue&type=script&lang=js&"
import style0 from "./BellList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BellList.vue?vue&type=style&index=1&id=26627674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26627674",
  null
  
)

export default component.exports